import { render, staticRenderFns } from "./AliOss.vue?vue&type=template&id=772b4178&scoped=true"
import script from "./AliOss.vue?vue&type=script&lang=js"
export * from "./AliOss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b4178",
  null
  
)

export default component.exports